
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press-release-feb-2015",
      function () {
        return require("private-next-pages/press-release-feb-2015.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/press-release-feb-2015"])
      });
    }
  